const enumValue = value => value?.databaseValue ?? value;

export const physicalStockQuantity = product =>
  Number(product.stockQuantity ?? (enumValue(product.state) === 'PREORDER' ? 0 : product.quantity ?? 0));

export const stockQuantitiesChanged = draft =>
  Number(draft.quantity) !== Number(draft.originalQuantity);

export const orderQuantityLimit = (item, orderStatus) => {
  const status = enumValue(orderStatus);
  const type = enumValue(item.productOrderType);
  const physicalLimit = Number(item.quantity || 0) + Number(item.stockQuantity || 0);
  if (status === 'SENT') return physicalLimit;
  if (
    ['CANCELLED', 'RETURNED'].includes(status) || type === 'TO_ORDER'
  )
    return Number.MAX_SAFE_INTEGER;
  return (
    physicalLimit + (type === 'PREORDER' ? Number(item.preorderAvailableQuantity || 0) : 0)
  );
};

export const isOrderItemInStock = item => enumValue(item?.productStatus) === 'IN_STOCK';

export const isOrderItemAwaitingStock = item =>
  !['IN_STOCK', 'RETURNED'].includes(enumValue(item?.productStatus));

export const orderReadyForShipment = order => {
  const items = order?.orderItems || [];
  return (
    items.length > 0 &&
    items.every(
      item =>
        isOrderItemInStock(item) &&
        Number(item.quantity) > 0 &&
        (item.stockReservedQuantity == null ||
          Number(item.stockReservedQuantity) >= Number(item.quantity)),
    )
  );
};
